var fix100vh = {
    init: function() {
        var doc = document.documentElement;
        doc.style.setProperty('--app-height', `${window.innerHeight}px`);

        window.addEventListener( 'resize', function() {
            var doc = document.documentElement;
            doc.style.setProperty('--app-height', `${window.innerHeight}px`);
        } );
    }
}

export { fix100vh };